<template>

      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Upload a new Schema JSON File</h5>
          <div v-if="currentFile" class="progress">
            <div
              class="progress-bar progress-bar-info progress-bar-striped"
              role="progressbar"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
              :style="{ width: progress + '%' }"
            >
              {{ progress }}%
            </div>
          </div>

          <label class="btn btn-default">
            <input type="file" ref="file" @change="selectFile" />
          </label>

          <button class="btn btn-success" :disabled="!selectedFiles" @click="upload">
            Upload
          </button>

          <div class="alert alert-light" role="alert">{{ message }}</div>

        </div>
    </div>
</template>
<script>

import {BackendApiService} from '../services/BackendApiService'

export default {
  name: 'file-upload',
  data () {
    return {
      selectedFiles: undefined,
      currentFile: undefined,
      progress: 0,
      message: '',

      fileInfos: []
    }
  },
  methods: {
    selectFile () {
      this.selectedFiles = this.$refs.file.files
    },
    upload () {
      this.progress = 0

      this.currentFile = this.selectedFiles.item(0)
      BackendApiService.upload(this.currentFile, event => {
        this.progress = Math.round((100 * event.loaded) / event.total)
      })
        .then(response => {
          this.message = response.data.message
        })
        .catch((e) => {
          this.progress = 0
          console.log('in catch clause')
          console.log(e.response)
          this.message = e.response.data.message
          this.currentFile = undefined
        })

      this.selectedFiles = undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FileUpload.vue